


























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AuditKebersihanAlatService from "@/services/AuditKebersihanAlatService";
import { KRITERIA_AUDIT_KEBERSIHAN_ALAT } from "@/constants/kriteriaAuditKebersihanAlat";

@Component
export default class AuditKebersihanAlatDetail extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;

  signDialog = false;
  signStage: "auditor" | "karu" | null = null;
  signPassword = "";
  signing = false;

  temuanDialog = false;
  temuanForm: any = {};
  savingTemuan = false;

  kesimpulanModel = "";

  kriteriaSelectOptions = KRITERIA_AUDIT_KEBERSIHAN_ALAT.map(k => ({
    text: `${k.no_label}. ${k.kriteria}`,
    value: k.no
  }));

  statusTemuanOptions = [
    { text: "Open", value: "open" },
    { text: "In Progress", value: "in_progress" },
    { text: "Closed", value: "closed" },
    { text: "Overdue", value: "overdue" }
  ];

  temuanHeaders = [
    { text: "#", value: "urutan", width: 40 },
    { text: "Item", value: "kriteria_no", width: 70 },
    { text: "Temuan", value: "uraian" },
    { text: "RTL", value: "rencana_tindak_lanjut" },
    { text: "PIC", value: "pic_nama" },
    { text: "Target", value: "target_waktu" },
    { text: "Status", value: "status_chip" },
    { text: "", value: "actions", sortable: false, width: 80 }
  ];

  signStages = [
    {
      key: "auditor",
      label: "Auditor / Tim PPI",
      sub: "Dibuat Oleh",
      timestampField: "signed_auditor_at",
      waitFor: "—",
      getName: (s: any) => s.auditor_nama || (s.auditor && s.auditor.identitas && s.auditor.identitas.nama),
      canSign: (s: any) => !s.signed_auditor_at
    },
    {
      key: "karu",
      label: "Ka. Ruang / Petugas Jaga",
      sub: "Mengetahui",
      timestampField: "signed_karu_at",
      waitFor: "Auditor",
      getName: (s: any) => s.signed_karu && s.signed_karu.identitas && s.signed_karu.identitas.nama,
      canSign: (s: any) => !!s.signed_auditor_at && !s.signed_karu_at
    }
  ];

  get signStageLabel() {
    const s = this.signStages.find(x => x.key === this.signStage);
    return s ? `${s.label} — ${s.sub}` : "";
  }

  get responsesTable() {
    const map: any = {};
    (this.session?.responses || []).forEach((r: any) => (map[r.kriteria_no] = r));
    let lastGrup: string | null = null;
    return KRITERIA_AUDIT_KEBERSIHAN_ALAT.map(k => {
      const r = map[k.no] || {};
      const groupHeader = k.kelompok && k.kelompok !== lastGrup ? k.kelompok : null;
      lastGrup = k.kelompok;
      return {
        no: k.no,
        no_label: k.no_label,
        indent: !!k.kelompok,
        groupHeader,
        kriteria: k.kriteria,
        penilaian: r.penilaian ?? null,
        catatan: r.catatan || ""
      };
    });
  }

  itemLabel(no: number | null): string {
    if (!no) return "—";
    const k = KRITERIA_AUDIT_KEBERSIHAN_ALAT.find(x => x.no === no);
    return k ? `${k.no_label}.` : String(no);
  }

  async mounted() {
    await this.loadSession();
  }

  async loadSession() {
    const res = await AuditKebersihanAlatService.find(this.sessionId);
    this.session = res.data.data;
    this.kesimpulanModel = this.session.kesimpulan_umum || "";
  }

  async saveKesimpulan() {
    if (this.session.is_locked) return;
    if ((this.kesimpulanModel || "") === (this.session.kesimpulan_umum || "")) return;
    await AuditKebersihanAlatService.update(this.session.id, {
      unit_id: this.session.unit_id,
      tanggal_audit: this.session.tanggal_audit,
      metode_audit: this.session.metode_audit,
      periode_bulan: this.session.periode_bulan,
      periode_tahun: this.session.periode_tahun,
      kesimpulan_umum: this.kesimpulanModel
    });
    this.session.kesimpulan_umum = this.kesimpulanModel;
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  formatDateTime(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleString("id-ID");
  }

  bulanName(b: number): string {
    const names = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    return names[b] || "";
  }

  printPdf() {
    AuditKebersihanAlatService.printPdf(this.session.id);
  }

  openSignDialog(stage: "auditor" | "karu") {
    this.signStage = stage;
    this.signPassword = "";
    this.signDialog = true;
  }

  async confirmSign() {
    if (!this.signStage) return;
    this.signing = true;
    try {
      const handlers: any = {
        auditor: AuditKebersihanAlatService.submitAuditor,
        karu: AuditKebersihanAlatService.acknowledgeKaru
      };
      await handlers[this.signStage](this.session.id, { password: this.signPassword });
      this.signDialog = false;
      await this.loadSession();
    } finally {
      this.signing = false;
    }
  }

  openTemuan(t?: any) {
    this.temuanForm = t
      ? { ...t }
      : {
          uraian: "",
          kriteria_no: null,
          akar_masalah: "",
          rencana_tindak_lanjut: "",
          pic_nama: "",
          target_waktu: "",
          status: "open"
        };
    this.temuanDialog = true;
  }

  async saveTemuan() {
    if (!this.temuanForm.uraian || !this.temuanForm.rencana_tindak_lanjut) return;
    this.savingTemuan = true;
    try {
      if (this.temuanForm.id) {
        await AuditKebersihanAlatService.updateTemuan(this.session.id, this.temuanForm.id, this.temuanForm);
      } else {
        await AuditKebersihanAlatService.storeTemuan(this.session.id, this.temuanForm);
      }
      this.temuanDialog = false;
      await this.loadSession();
    } finally {
      this.savingTemuan = false;
    }
  }

  async deleteTemuan(t: any) {
    if (!confirm(`Hapus temuan #${t.urutan}?`)) return;
    await AuditKebersihanAlatService.destroyTemuan(this.session.id, t.id);
    await this.loadSession();
  }
}
